
import {Component, Prop} from 'vue-property-decorator'
import {Base} from '~/core/Base'
import {StringHelper} from '~/utils/StringHelper'

@Component
export default class LabelAlias extends Base {
  @Prop(String) readonly className!: string

  async copy() {
    const copyText = this.$slots!.default![0].text || ''
    try {
      await StringHelper.copyToClipBoard(copyText)
      this.$toast.show('Copied: ' + copyText, {
        icon: 'assignment_turned_in',
        duration: 1000
      })
    } catch (error) {
      this.$toast.show('Unable to copy to clipboard', { icon: 'error' })
    }
  }
}
